import { type FC, type PropsWithChildren } from 'react'
import { twMerge } from 'tailwind-merge'
import cx from 'classnames'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { EnrollmentHeader, UnauthenticatedHeader } from '../components'

interface EnrollmentLayoutProps extends PropsWithChildren {
  className?: string
  title?: string
  hideHeader?: boolean
}

export const EnrollmentLayout: FC<EnrollmentLayoutProps> = ({
  children,
  className,
  title = 'Enrollment',
  hideHeader = false,
}) => {
  const baseClass = cx('h-full flex')
  const finalClasses = twMerge(baseClass, className)

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>{title}</title>
          <meta
            name="description"
            content="Evergreen Wealth is a comprehensive advisory service that is a technology-driven, human-advised, and tax efficient way to manage all your money."
          />
        </Helmet>
      </HelmetProvider>
      <div className="h-full flex flex-col overflow-auto">
        {!hideHeader && <EnrollmentHeader exitLink={WEALTH_ROUTES.INVESTMENTS.path} />}
        <div className="flex-1">
          <div className={finalClasses}>{children}</div>
        </div>
      </div>
    </>
  )
}

interface EnrollmentV2LayoutProps extends PropsWithChildren {
  className?: string
  title?: string
  closeHandler: () => void | Promise<void>
}

export const EnrollmentV2Layout: FC<EnrollmentV2LayoutProps> = ({
  children,
  className,
  title = 'Investments',
  closeHandler,
}) => {
  const { t } = useTranslation('layouts')
  const baseClass = cx('egw-container-enroll-multi')
  const finalClasses = twMerge(baseClass, className)

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={t('header.meta_content')} />
        </Helmet>
      </HelmetProvider>
      <div className="h-full flex flex-col overflow-auto">
        <UnauthenticatedHeader closeHandler={closeHandler} />
        <div className="flex-1">
          <div className={finalClasses}>{children}</div>
        </div>
      </div>
    </>
  )
}
